/**
 * "The Library may have changed": sent after a save is CONFIRMED, so a Library page that is still mounted
 * (beside the candidate canvas, which does not remount it) reads again. A signal only: nothing is cached,
 * stored or polled, and each listener decides how to refresh (the Library hook re-runs its one read).
 */
export const LIBRARY_CHANGED = 'poneva:artifact-library-changed';

export function notifyLibraryChanged(): void {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(LIBRARY_CHANGED));
}
